import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { ErrorDialogService } from 'src/app/error/error-dialog.service';



@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  private settings: Settings;
  private dialogRef: any;
  private isDialogOpen: boolean = false;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private appSettings: AppSettings,
    private errorDialogService: ErrorDialogService) {

    this.settings = appSettings.settings;
  }





  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        retry(1),
        catchError((err: HttpErrorResponse) => {

          console.log('catching error: ' + err.status);
          const data = {
            reason: err && err.error && err.error.reason ? err.error.reason : '',
            status: err.status,
            result: null
          };

          // Error 0: server is not responding or return undefined error.
          if (err.status === 0) {
            const msg = this.translate.instant(`ERROR.CODE.0`);
            // this.router.navigate(['/login']);
            return throwError(msg);
          }

         
          // Error 401: unauthorized
          if (err.status === 401) {
            
            console.log('unauthorized 401');
            this.router.navigate(['/login']);
            return throwError(data.reason);
          
          } else if (err.status === 515) {
            // Error 515: disconnected
            console.log('Error 515: You are disconnected because the system recognized you connected elsewhere.');
            const msg = this.translate.instant(`ERROR.CODE.515`);
            data.reason = msg;
            data.status = 515;

            if (!this.isDialogOpen) {
              // show error dialog. after closing the dialog redirect to login page
              this.isDialogOpen = true;
              this.dialogRef = this.errorDialogService.openDialog(data);
              this.dialogRef.afterClosed().subscribe(result => {
                // you can recive result also from data.result;
                this.isDialogOpen = false;
                this.router.navigate(['/login']);
              });
            }


            return throwError(data.reason);

          } else {
            // other error
            let errorMessage = '';
            if (err.error instanceof ErrorEvent) {
              // client-side error
              errorMessage = `Error: ${err.error.message}`;
            } else {
              // server-side error
              errorMessage = `Error Code: ${err.status}\nMessage: ${err.message}`;
            }

            const error = (err.error && err.error.message) || err.statusText;
           
            return throwError(errorMessage);
          }

        })
      );
  }
}